/**
 * WorkAxis — shared page building blocks.
 */
import React, {useEffect} from 'react';
import {Link} from "react-router-dom";

export function useReveal() {
    useEffect(() => {
        const els = document.querySelectorAll('.wx-reveal');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {threshold: 0.12});
        els.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);
}

export function PageHero({kicker, title, lead}) {
    return (
        <header className="wx-page-hero">
            <div className="wx-container">
                <div className="wx-kicker">{kicker}</div>
                <h1 className="wx-h1">{title}</h1>
                {lead && <p className="wx-lead">{lead}</p>}
            </div>
        </header>
    );
}

export function CtaSection({title, text, primaryLabel}) {
    const label = primaryLabel || "Discuss your project";
    return (
        <section className="wx-section">
            <div className="wx-container">
                <div className="wx-cta wx-reveal">
                    <h2>{title || <>Have a process that's <span className="wx-grad-text">hard to scale?</span></>}</h2>
                    <p>{text || "Tell us what you're trying to automate or build. We respond within one business day."}</p>
                    <div className="wx-cta-actions">
                        <Link to="/contact" className="wx-btn wx-btn-primary">{label}</Link>
                        <a href="mailto:hello@workaxis.in" className="wx-btn wx-btn-ghost">hello@workaxis.in</a>
                    </div>
                </div>
            </div>
        </section>
    );
}
